module.exports = __webpack_public_path__ + "img/cg.5e9e55ee.png";